var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest } from "../../lib";
import { failureHash } from "./pageconfig_old.static";
export class ApiEpPageConfigOld {
}
_a = ApiEpPageConfigOld;
/**
 * Used to change SocialPageConfig account settings (priority)
 */
ApiEpPageConfigOld.accountSettingsUpgrade = ({ pageConfigAccount, }) => apiRequest({
    body: Object.assign({}, pageConfigAccount),
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount/${pageConfigAccount.id}`,
    method: "PATCH",
}, failureHash);
/**
 * Used to create new SocialPageConfig
 */
ApiEpPageConfigOld.create = ({ fields, pageConfig, }) => apiRequest({
    body: pageConfig,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig`,
    method: "POST",
    query: fields
        ? {
            fields,
        }
        : undefined,
}, failureHash);
/**
 * Used to delete SocialPageConfig by id
 */
ApiEpPageConfigOld.destroy = ({ id, transferPageConfigId, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig/${id}?transferPageConfigId=${transferPageConfigId || ""}`,
    method: "DELETE",
}, failureHash);
/**
 * Used to get SocialPageConfigs
 */
ApiEpPageConfigOld.get = ({ fields, has_publish_permission, has_schedule, is_hidden, medium, medium_external_id, medium_external_id__in, page_name, update, }) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig`,
        method: "GET",
        query: {
            fields,
            has_publish_permission,
            has_schedule,
            is_hidden,
            medium,
            medium_external_id,
            medium_external_id__in,
            page_name,
            update,
        },
    }, failureHash);
});
/**
 * Used to get SocialPageConfig accounts
 */
ApiEpPageConfigOld.getAccounts = () => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount`,
    method: "GET",
}, failureHash);
/**
 * Used to get SocialPageConfig account settings (publish priority)
 */
ApiEpPageConfigOld.getAccountSettings = ({ id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfigaccount?page_config=${id}`,
    method: "GET",
}, failureHash);
/**
 * Used to get SocialPageConfig by id
 */
ApiEpPageConfigOld.retrieve = ({ fields, id, }) => apiRequest({
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig/${id}`,
    method: "GET",
    query: fields
        ? {
            fields,
        }
        : undefined,
}, failureHash);
/**
 * Used to PATCH update SocialPageConfig
 */
ApiEpPageConfigOld.update = ({ fields, data, organizationId, }) => apiRequest({
    body: data,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig/${data.id}`,
    method: "PATCH",
    headers: organizationId
        ? [["X-Organization-Context", organizationId.toString()]]
        : undefined,
    query: fields
        ? {
            fields,
        }
        : undefined,
}, failureHash);
/**
 * Used to PUT update SocialPageConfig
 */
ApiEpPageConfigOld.rewrite = ({ fields, data, }) => apiRequest({
    body: data,
    endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/pageconfig/${data.id}`,
    method: "PUT",
    query: fields
        ? {
            fields,
        }
        : undefined,
}, failureHash);
//# sourceMappingURL=pageconfig_old.js.map